import type {
  ComponentType,
  ComponentProps,
  JSXElementConstructor,
  JSX
} from 'react'

import {
  type JSXComponent,
  mapReadPretty as _mapReadPretty,
  observer as _observer
} from '@formily/react'

export {
  connect,
  mapProps,
  ExpressionScope,
  ObjectField,
  useField,
  useForm,
  useExpressionScope,
  useFormEffects
} from '@formily/react'

// https://github.com/microsoft/TypeScript/pull/58176#issuecomment-2052698294
export const observer = _observer as <T extends JSXComponent>(
  target: T
) => ComponentType

export const mapReadPretty = _mapReadPretty as <
  T extends JSXComponent,
  C extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
>(
  component: C,
  readPrettyProps?: Partial<ComponentProps<C>>
) => (target: T) => JSXComponent
